import { Singleton } from '@denishussar/html5-game-engine';

@Singleton
export class FuelModel {
    public step: number= 1;
    public steps: number = 3;

    constructor() {
    }

    public clear(): void {
        this.step = 1;
        this.steps = 3;
    }
}
